!function() {
  "use strict";
  customElements.get("details-disclosure") || customElements.define("details-disclosure", class extends HTMLElement {
    constructor() {
      super(), this.details = this.querySelector("details"), this.summary = this.querySelector("summary"), 
      this.scrollLock = this.hasAttribute("data-scroll-lock"), this.isMenu = this.hasAttribute("data-menu"), 
      this.disableClose = this.hasAttribute("data-disable-close"), this.disableClose || this.details.addEventListener("focusout", this.onFocusOut.bind(this)), 
      this.summary.addEventListener("focusin", this.onFocusIn.bind(this)), this.details.addEventListener("toggle", this.onToggle.bind(this)), 
      this.addEventListener("click", this.onClick.bind(this)), this.hasAttribute("data-hover") && (this.hasAttribute("data-timeout") && (this.timeout = null, 
      this.delay = 100), this.summary.addEventListener("mouseenter", this.onMouseEnter.bind(this)), 
      this.hasAttribute("data-timeout") && this.summary.addEventListener("mouseleave", this.onMouseLeave.bind(this)), 
      this.summary.addEventListener("click", (event => event.preventDefault())));
    }
    onFocusIn() {
      setTimeout((() => {
        this.details.open || (this.details.open = !0);
      }), 500);
    }
    onFocusOut() {
      setTimeout((() => {
        this.contains(document.activeElement) || this.querySelector("details details:focus") || this.querySelector("details summary:focus") || this.close();
      }), 500);
    }
    onClick(event) {
      this.disableClose && event.target == this.summary ? event.preventDefault() : event.target.hasAttribute("data-close") && (event.preventDefault(), 
      this.close());
    }
    onMouseEnter(event) {
      this.hasAttribute("data-timeout") ? (clearTimeout(this.timeout), this.timeout = setTimeout((() => {
        this.details.open = !0;
      }), this.delay)) : this.details.open = !0;
    }
    onMouseLeave(event) {
      clearTimeout(this.timeout);
    }
    onToggle() {
      this.animations || (this.animations = this.summary.getAnimations()), this.details.hasAttribute("open") ? (this.animations.forEach((animation => animation.play())), 
      this.querySelector("summary ~ *").querySelectorAll(".overflow-auto,.overflow-y-auto").forEach((el => el.scrollTo({
        top: 0,
        behavior: "instant"
      }))), this.querySelector("summary ~ *").querySelectorAll('[type="email"],[type="password"]').forEach((el => el.value = ""))) : (this.animations.forEach((animation => animation.cancel())), 
      this.querySelectorAll("details").forEach((details => details.removeAttribute("open")))), 
      this.details.hasAttribute("open") ? setTimeout((() => {
        this.scrollLock && document.body.classList.add("tablet:overflow-clip"), this.isMenu && document.body.classList.add("is-menu-open"), 
        this.summary.setAttribute("aria-expanded", !0);
      })) : (this.scrollLock && document.body.classList.remove("tablet:overflow-clip"), 
      this.isMenu && document.body.classList.remove("is-menu-open"), this.summary.setAttribute("aria-expanded", !1));
    }
    close() {
      this.details.removeAttribute("open"), this.summary.setAttribute("aria-expanded", !1);
    }
  });
}();